'use client';

import { useEffect, useState } from 'react';

const DEBOUNCE_MS = 400;

export function useDebounceSearch(): {
  query: string;
  activeQuery: string;
  setQuery: (q: string) => void;
  applySearch: (nextQuery?: string) => void;
} {
  const [query, setQuery] = useState('');
  const [activeQuery, setActiveQuery] = useState('');

  useEffect((): (() => void) => {
    const timer = setTimeout((): void => {
      setActiveQuery(query);
    }, DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [query]);

  const applySearch = (nextQuery?: string): void => {
    if (nextQuery === undefined) {
      setActiveQuery(query);
      return;
    }

    setQuery(nextQuery);
    setActiveQuery(nextQuery);
  };

  return { query, activeQuery, setQuery, applySearch };
}
